import { render, staticRenderFns } from "./Trademarks-Concern.vue?vue&type=template&id=64369105&scoped=true&"
import script from "./Trademarks-Concern.vue?vue&type=script&lang=js&"
export * from "./Trademarks-Concern.vue?vue&type=script&lang=js&"
import style0 from "./Trademarks-Concern.vue?vue&type=style&index=0&id=64369105&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64369105",
  null
  
)

export default component.exports